<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-marketing-site-bottom-menu-item-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Bottom Menu Item
            </h4>
          </div>

          <div class="modal-body">
            <text-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="getError('text')"
            />

            <text-form-group
                v-model="data.url"
                name="url"
                label="URL"
                :error="getError('url')"
            />

            <radio-form-group
                v-model="data.is_highlighted"
                name="is_highlighted"
                label="Highlighted"
                :error="getError('is_highlighted')"
                :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {RadioFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    portal: {
      required: true
    },

    language: {
      required: true
    }
  },

  data() {
    return {
      data: {
        is_highlighted: false
      }
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/marketing-site-menu-items', {
        ...this.data,
        language: this.language,
        location: 'bottom',
        portal_id: this.portal.id
      })
          .then(response => {
            notify.success('The menu item was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
